// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".PaticipantMenue[data-v-d5816830]{position:relative;z-index:99}.userMenue[data-v-d5816830]{position:absolute;width:90%;right:20px;background:#fff;filter:drop-shadow(0 0 10px rgba(0,0,0,.2))}.material-design-icon[data-v-d5816830]{height:25px;width:25px}.material-design-icon>.material-design-icon__svg[data-v-d5816830]{fill:#000;height:25px;width:25px}.md-list-item-icon[data-v-d5816830]{margin-right:10px}.md-list-item-text[data-v-d5816830]{font-size:14px}", ""]);
// Exports
module.exports = exports;
